export default "__VITE_ASSET__DmkrwtLT__"